import { BadgeWithDot } from "@admin-ui/components/primitives/base/badges/badges";
import { formatDate } from "@admin-ui/utils/format-date";

/** Lifecycle states across erasable entities; accounts only ever use a subset. */
export type LifecycleState = "waitlisted" | "active" | "anonymized";

const LIFECYCLE_COLORS = {
  active: "success",
  waitlisted: "warning",
  anonymized: "gray",
} as const;

export interface LifecycleBadgeProps {
  lifecycleState: LifecycleState;
  /** ISO timestamp shown alongside the anonymized label; ignored otherwise. */
  anonymizedAt?: string | null;
}

/**
 * Renders an entity's derived lifecycle state. Anonymization is terminal, so it
 * shows as a neutral "Anonymized · <date>" tombstone rather than the misleading
 * green "active" the raw funnel status would render.
 */
export function LifecycleBadge({ lifecycleState, anonymizedAt }: LifecycleBadgeProps) {
  if (lifecycleState === "anonymized") {
    return (
      <BadgeWithDot color="gray" size="sm">
        {anonymizedAt ? `Anonymized · ${formatDate(anonymizedAt)}` : "Anonymized"}
      </BadgeWithDot>
    );
  }

  return (
    <BadgeWithDot color={LIFECYCLE_COLORS[lifecycleState]} size="sm">
      {lifecycleState}
    </BadgeWithDot>
  );
}
